












import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Languages extends Vue {
  private get locale(): string {
    return this.$store.getters['app/locale'];
  }

  private get locales(): object {
    return this.availableLocales.filter((l: any) => l.code !== this.locale);
  }

  private get availableLocales(): object[] {
    return this.$config.i18n.availableLocale;
  }
}
